import React from 'react'
import styles from './styles.module.scss'

interface FaqSectionProps {
    onScrollToForm: () => void
}

export const FaqSection: React.FC<FaqSectionProps> = ({ onScrollToForm }) => {
    return (
        <section className={styles.faqSection}>
            <div className={styles.container}>
                <div className={styles.sectionHeader}>
                    <h2>Frequently Asked Questions</h2>
                    <p>Get answers to the most common questions about irresponsible lending claims</p>
                </div>
                <div className={styles.faqGrid}>
                    <div className={styles.faqItem}>
                        <h4>How do I know if I have a valid claim?</h4>
                        <p>
                            If you struggled to make payments, weren't properly assessed for affordability, or were sold
                            an unsuitable product, you may have a valid claim. Our free assessment will determine your
                            eligibility.
                        </p>
                    </div>
                    <div className={styles.faqItem}>
                        <h4>How much compensation could I receive?</h4>
                        <p>
                            Compensation varies depending on your individual circumstances, but successful claims often
                            result in refunds of interest and charges, plus additional compensation for distress and
                            inconvenience.
                        </p>
                    </div>
                    <div className={styles.faqItem}>
                        <h4>How long does the process take?</h4>
                        <p>
                            Most cases are resolved within 6-12 months, though complex cases may take longer. We'll keep
                            you updated throughout the entire process.
                        </p>
                    </div>
                    <div className={styles.faqItem}>
                        <h4>What if I've already sold or returned the car?</h4>
                        <p>
                            You can still make a claim even if you no longer have the vehicle. The key factor is whether
                            the original finance agreement was sold irresponsibly.
                        </p>
                    </div>
                </div>
                <div className={styles.ctaCenter}>
                    <button className={styles.ctaButton} onClick={onScrollToForm}>
                        Get Your Free Assessment
                    </button>
                </div>
            </div>
        </section>
    )
}
